const TRACKING_KEYS = {
  gclid: 'bodex_gclid',
  wbraid: 'bodex_wbraid',
  gbraid: 'bodex_gbraid',
  utm_source: 'bodex_utm_source',
  utm_medium: 'bodex_utm_medium',
  utm_campaign: 'bodex_utm_campaign',
  utm_content: 'bodex_utm_content',
  utm_term: 'bodex_utm_term'
};

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const storeTrackingParams = (searchParams) => {
  if (!isBrowser() || !searchParams) return;
  
  let stored = false;
  Object.entries(TRACKING_KEYS).forEach(([paramKey, storageKey]) => {
    const value = searchParams.get(paramKey);
    if (value) {
      window.localStorage.setItem(storageKey, value);
      stored = true;
    }
  });
  
  if (stored) {
    window.localStorage.setItem('bodex_tracking_last_seen', new Date().toISOString());
  }
};

export const getStoredTrackingParams = () => {
  const collected = {};
  if (!isBrowser()) {
    return collected;
  }
  
  Object.entries(TRACKING_KEYS).forEach(([paramKey, storageKey]) => {
    const value = window.localStorage.getItem(storageKey);
    if (value) {
      collected[paramKey] = value;
    }
  });
  
  return collected;
};

export const clearTrackingParams = () => {
  if (!isBrowser()) return;
  Object.values(TRACKING_KEYS).forEach(storageKey => window.localStorage.removeItem(storageKey));
  window.localStorage.removeItem('bodex_tracking_last_seen');
};

